import React, { useContext } from "react";
import _ from "lodash";
import AppContext from "../AppContext";
import { BoldCaption, InfoCaption, Select, If } from "../Components";
import { getTranslateByScope } from "../i18n";
import {
  mapCustomerAddressToDropdown,
  mapCustomerAddressesFromJSON,
} from "../utils/customer";
import { getCustomerAddressesForCustomer } from "../selectors";

import "./SelectCustomerDropdown.scss";

const translate = getTranslateByScope("app.addressDropdown");

const addrJoin = (arr, sep) =>
  _.join(_.compact(_.map(arr, (x) => _.trim(x, ", "))), sep);

const AddressDropdownItem = (address) => {
  if (!address) return null;

  const name = addrJoin([address.name, address.name2], ", ");
  const addr = addrJoin([address.street, address.number], ", ");
  const city = addrJoin(
    [address.postalCode, addrJoin([address.city, address.country], ", ")],
    " ",
  );

  return (
    <>
      <If condition={name}>{() => <BoldCaption>{name}</BoldCaption>}</If>
      <InfoCaption>
        {addr}
        <br />
        {city}
      </InfoCaption>
    </>
  );
};

const mapAddressItem = (address) => ({
  ...address,
  value:
    address.city +
    address.state +
    address.country +
    address.street +
    address.BillingStreet,
  label: AddressDropdownItem(address),
});

const formatCustomerAddresses = (addresses) =>
  addresses.map((a) => mapAddressItem(mapCustomerAddressesFromJSON(a)));

const mapSelectedAddress = (address) => ({
  name: address.name,
  name2: address.name2,
  city: address.city,
  state: address.state,
  postalCode: address.postalCode,
  country: address.country,
  street: address.street,
  shipToCode: address.shipToCode,
});

export const AddressDropdown = ({
  translations,
  address,
  onChange,
  customer,
  isDisabled,
}) => {
  const context = useContext(AppContext);
  const addresses = getCustomerAddressesForCustomer(context, customer);
  const options = formatCustomerAddresses(
    mapCustomerAddressToDropdown(_.values(addresses)),
  );

  return (
    <div className="addrDropDown">
      <b>{translations.title}</b>
      <Select
        isDisabled={isDisabled}
        key={address}
        value={address ? mapAddressItem(address) : null}
        onChange={(a) => onChange(mapSelectedAddress(a))}
        options={options}
        placeholder={translate("placeholder")}
      />
    </div>
  );
};

export default AddressDropdown;
